import "./it-solutions.css";
import { useNavigate } from "react-router-dom";
import Timeline from "../../../components/timeline/timeline-comp";
import { useTranslation } from "react-i18next";

export default function ItSolutions() {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const goToContact = () => {
    navigate("/contact-us");
  };

  const goToAbout = () => {
    navigate("/about-us");
  };

  const timelineData = [
    {
      date: "01",
      title: "Scalable Infrastructure",
      content: "Scalable infrastructure that adapts to your business needs.",
    },
    {
      date: "02",
      title: "Cost-Effective Solutions",
      content:
        "Cost-efficiency through pay-as-you-go models and reduced infrastructure costs.",
    },
    {
      date: "03",
      title: "Seamless Collaboration",
      content: "Enhanced collaboration and remote work capabilities.",
    },
    {
      date: "04",
      title: "Robust Data Protection",
      content: "Improved disaster recovery and data backup solutions.",
    },
    {
      date: "05",
      title: "Agile Deployment",
      content:
        "Increased agility and flexibility in deploying new applications and services.",
    },
  ];

  const challenges = [
    {
      number: "01",
      text: "Struggles with data silos, lack of analytics expertise, and ineffective tools.",
    },
    {
      number: "02",
      text: "Hampers decision-making, impedes growth, and limits capitalizing on opportunities.",
    },
    {
      number: "03",
      text: "Legacy systems and slow adoption of new technologies reduce agility and scalability.",
    },
  ];

  const cards = [
    {
      icon: "fa-solid fa-handshake",
      title: "Commitment",
      text: "Technical expertise combined with advanced analytics capabilities.",
    },
    {
      icon: "fa-solid fa-chart-line",
      title: "Analysis",
      text: "Collaborative approach understanding business objectives and data requirements.",
    },
    {
      icon: "fa-solid fa-network-wired",
      title: "Openness",
      text: "Customized IT solutions seamlessly integrating with existing systems for maximizing data potential.",
    },
  ];

  return (
    <div className="main-container">
      {/* main image section */}
      <section className="main-image-section">
        <div className="main-image-dark-effect">
          <h6 className="sub-container-sub-heading">{t("Services")}</h6>
          <h1 className="sub-container-heading">{t("IT Solutions")}</h1>
          <p className="sub-container-desc">
            {t("Empower your business with innovative IT solutions designed to streamline operations, enhance security, and drive digital transformation. From infrastructure optimization to cloud integration, our solutions enable smarter, faster, and more efficient ways to achieve your goals.")}
          </p>
          <div className="main-img-container-buttons">
            <button
              type="button"
              className="img-contact-btn common-btn-styles"
              onClick={goToContact}
            >
              {t("Contact Us")}
            </button>
            <button
              type="button"
              className="img-about-btn common-btn-styles"
              onClick={goToAbout}
            >
              {t("About Us")}
            </button>
          </div>
        </div>
      </section>

      {/* service overview section */}
      <section className="service-overview">
        <div className="service-overview-width sub-container">
          <div>
            <h1 className="sub-container-heading">{t("Service Overview")}</h1>
          </div>

          <div className="service-img-container">
            <div className="service-image">
              <img
                src="/assets/images/it-solutions-service-overview.jpg"
                alt="It Solutions Overview"
              />
            </div>

            {/* Right Content */}
            <div className="service-content">
              <p>
                {t("Delivering innovative IT solutions that modernize infrastructure, enhance efficiency, and drive digital transformation to help businesses stay ahead in a rapidly evolving tech landscape.")}
              </p>
              <ul>
                <li>
                  <i className="fa-solid fa-angles-right"></i> {t("Comprehensive IT solutions empowering growth and data-driven decision-making.")}
                </li>
                <li>
                  <i className="fa-solid fa-angles-right"></i> {t("Business analytics tools for analyzing, visualizing, and interpreting valuable insights.")}
                </li>
                <li>
                  <i className="fa-solid fa-angles-right"></i> {t("Tailored solutions for gaining a competitive edge and enhancing operational efficiency.")}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/*challenges secton*/}
      <section className="challenges-section sub-container">
        <h2 className="sub-container-heading">{t("Challenges")}</h2>
        <p className="sub-container-desc">
          {t("Common IT challenges organizations face in today’s digital landscape.")}
        </p>

        <div className="challenges-container">
          {challenges.map((item, index) => (
            <div
              className="challenge-box"
              key={index}
              data-number={item.number}
            >
              <p className="challenge-text">{t(item.text)}</p>
            </div>
          ))}
        </div>
      </section>

      {/* how are we solving section */}
      <section className="solving-section">
        <div className="solving-section-container sub-container">
          <h1 className="sub-container-heading">{t("How Are We Solving")}</h1>
          <p className="sub-container-desc">
            {t("We combine innovation, expertise, and collaboration to deliver scalable IT solutions that empower businesses to make smarter, data-driven decisions.")}
          </p>

          <div className="solving-cards">
            {cards.map((card, index) => (
              <div className="solving-card" key={index}>
                <div className="icon-wrapper">
                  <i className={card.icon}></i>
                </div>
                <h3>{t(card.title)}</h3>
                <p>{t(card.text)}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* benefits section */}
      <section className="benefits-section sub-container">
        <h1 className="sub-container-heading">{t("Benefits")}</h1>
        <p className="sub-container-desc">{t("With the quality and approach, we would be delivering the best of what you’d need in consulting, suggesting, providing right solutions thus yielding best benefits for your organizations productivity.")}
        </p>
        <div>
          <Timeline timelineData={timelineData} />
        </div>
      </section>
    </div>
  );
}
